import React from 'react'
import ScrollableContainer from '../../../Components/BonusUi/Scrollable'

export default function Scrollable() {
  return (
    <div className='page-body'>
        <ScrollableContainer/>
    </div>
  )
}
